import { Injectable } from '@angular/core';
import { RxTextCompositeComponent } from '@nrwl/rx-forms';
import { DialogsConfigService } from '../dialogs-config.service';

@Injectable({
  providedIn: 'root',
})
export class AdminDialogService extends DialogsConfigService {
  constructor() {
    super();
  }

  public lmsLogin() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Important',
        tip: `To ensure your courses and progress are connected under a single ElevateNow account, please use the same email address for all PatientNow products. This will help maintain consistency and access across all platforms.`,
        showAgainSettings: {
          value: false,
        },
        buttons: this.SubmitDismissButtons('Continue', 'Cancel'),
      },
    };
  }
}
